export default __webpack_public_path__ + "static/media/homer_simpson.c14a7805.gif";